import { createFileRoute, redirect } from "@tanstack/react-router";

/** The page moved to /app; this keeps older links and printed codes working. */
export const Route = createFileRoute("/handheld")({
  beforeLoad: () => {
    throw redirect({ to: "/app" });
  },
});
